import { Typography, Box, Button } from '@mui/material';
import ImportExportIcon from '@mui/icons-material/ImportExport';
import RefreshIcon from '@mui/icons-material/Refresh';
import { useState } from 'react';
import { PageHeader } from '../components/PageHeader';
import { ApiCallsList } from '../components/ApiCallsList';

export function ApiCallsPage() {
    const [refreshTrigger, setRefreshTrigger] = useState(0);

    const handleRefresh = () => {
        setRefreshTrigger((prev) => prev + 1);
    };

    return (
        <PageHeader currentPath="/api-calls">
            <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', mb: 1.5 }}>
                <Box sx={{ display: 'flex', alignItems: 'center' }}>
                    <ImportExportIcon
                        sx={{ fontSize: 28, mt: 0.3, mr: 1.5, color: 'primary.main', transform: 'scaleX(-1)' }}
                    />
                    <Typography variant="h5" component="h1" fontWeight={600}>
                        API Calls
                    </Typography>
                </Box>
                <Button variant="outlined" startIcon={<RefreshIcon />} onClick={handleRefresh}>
                    Refresh
                </Button>
            </Box>

            <ApiCallsList refreshTrigger={refreshTrigger} />
        </PageHeader>
    );
}
